import { Card, CardContent } from '@mui/material';
import { navigate } from 'gatsby';
import React, { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { MANAGE_SUBSCRIPTION } from '@constants/routes';

import ManageAccountLayout from '@views/ManageAccount/ManageAccountLayout';
import ChangeBillingAddressForm from '@views/ManageAccount/Payment/ChangeBillingAddress';
import ChangePaymentInfo from '@views/ManageAccount/Payment/ChangePaymentInfo';
import Invoices from '@views/ManageAccount/Payment/Invoices';

const messages = defineMessages({
  billingAddress: {
    id: 'managePayment.billing-address',
    defaultMessage: 'Manage Payment Billing Address',
  },
  invoices: {
    id: 'managePayment.invoices',
    defaultMessage: 'Invoices',
  },
  paymentDetails: {
    id: 'managePayment.payment-details',
    defaultMessage: 'Manage Payment Details',
  },
  fallback: {
    id: 'manageAccount.paymentBilling',
    defaultMessage: 'Payment and Billing',
  },
});

enum UpdatePaymentBillingSettingParam {
  Invoices = 'invoices',
  PaymentDetails = 'payment-details',
  BillingAddress = 'billing-address',
}

export default function UpdatePaymentBillingInfo(
  props: PagePropsWithBreadcrumbs
) {
  const { formatMessage } = useIntl();
  const section = props.params.section;
  const title =
    formatMessage({
      id: `managePayment.${section}`,
    }) || formatMessage(messages.fallback);

  useEffect(() => {
    if (
      !section ||
      !Object.values<string>(UpdatePaymentBillingSettingParam).includes(section)
    ) {
      navigate(MANAGE_SUBSCRIPTION);
    }
  }, [section]);

  const updatedCrumbs = props.pageContext.breadcrumb.crumbs.map((crumb) => {
    if (crumb.crumbLabel === '[section]') {
      return { ...crumb, crumbLabel: title, pathname: props.uri };
    }
    return crumb;
  });

  const updatedProps = {
    ...props,
    pageContext: {
      breadcrumb: {
        ...props.pageContext.breadcrumb,
        crumbs: updatedCrumbs,
      },
    },
  };

  return (
    <ManageAccountLayout friendlyName={title} pageProps={updatedProps}>
      {({ account, loading }) => {
        switch (section) {
          case UpdatePaymentBillingSettingParam.BillingAddress:
            return (
              <Card>
                <CardContent>
                  <ChangeBillingAddressForm
                    account={account}
                    loading={loading}
                  />
                </CardContent>
              </Card>
            );
          case UpdatePaymentBillingSettingParam.Invoices:
            return <Invoices account={account} loading={loading} />;
          case UpdatePaymentBillingSettingParam.PaymentDetails:
            return (
              <Card>
                <CardContent>
                  <ChangePaymentInfo account={account} loading={loading} />
                </CardContent>
              </Card>
            );
          default:
            return null;
        }
      }}
    </ManageAccountLayout>
  );
}
